<template>
  <div id="page">
    <component :is="pageComponent"></component>
    <!-- <vo-settings></vo-settings> -->
  </div>
</template>

<script>

  export default {
    data () {
      return {

      }
    },
    props: {
      pageComponent: {
        required: true
      }
    }
  }

</script>

<style lang="scss">

  @import '../css/global.scss';

  #page {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: $white;
  }

</style>



// WEBPACK FOOTER //
// src/components/Page.vue